"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNetworkInfo = void 0;
const axios_1 = __importDefault(require("axios"));
exports.getNetworkInfo = (chainId) => __awaiter(void 0, void 0, void 0, function* () {
    const infos = yield axios_1.default('https://chainid.network/chains.json');
    const chainIdNumber = typeof chainId === 'string' ? parseInt(chainId) : chainId;
    const chain = infos.data.filter(network => network.chainId === chainIdNumber);
    if (chain.length === 0) {
        throw new Error('Chain not found');
    }
    return chain[0];
});
//# sourceMappingURL=networkInfos.helper.js.map